// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profilePage__gO0Ct:has(.btnsBlock__LfgZH) {
  padding-bottom: 75px;
}

.profileFieldsBlock__mnCkD {
  display: grid;
  grid-template-columns: 1fr 1fr 450px;
  padding: 25px;
  grid-gap: 25px;
}
@media (max-width: 1600px) {
  .profileFieldsBlock__mnCkD {
    grid-template-columns: 1fr 1fr 400px;
  }
}
@media (max-width: 1400px) {
  .profileFieldsBlock__mnCkD {
    grid-template-columns: 1fr 1fr 300px;
  }
}
@media (max-width: 1300px) {
  .profileFieldsBlock__mnCkD {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 810px) {
  .profileFieldsBlock__mnCkD {
    padding: 15px;
  }
}

.containerTitle__hpz36 {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
}

.fieldsContainer__tUQVM {
  margin-top: 10px;
  padding: 20px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.notificationsInfoContainer__Q4aWt {
  grid-column: 1/3;
}

.btnsBlock__LfgZH {
  width: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  column-gap: 25px;
  padding: 25px;
  border-top: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Profile/style.module.scss"],"names":[],"mappings":"AA2EE;EACE,oBAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,oCAAA;EACA,aAAA;EACA,cAAA;AA3EF;AA6EE;EANF;IAOI,oCAAA;EA1EF;AACF;AA4EE;EAVF;IAWI,oCAAA;EAzEF;AACF;AA2EE;EAdF;IAeI,8BAAA;EAxEF;AACF;AA0EE;EAlBF;IAmBI,aAAA;EAvEF;AACF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;AAvEF;;AA0EA;EACE,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,wCAAA;AAvEF;;AA0EA;EACE,gBAAA;AAvEF;;AA0EA;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,qDAAA;EACA,UAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.profilePage {\n  &:has(.btnsBlock) {\n    padding-bottom: 75px;\n  }\n}\n\n.profileFieldsBlock {\n  display: grid;\n  grid-template-columns: 1fr 1fr 450px;\n  padding: 25px;\n  grid-gap: 25px;\n\n  @media (max-width: 1600px) {\n    grid-template-columns: 1fr 1fr 400px;\n  }\n\n  @media (max-width: 1400px) {\n    grid-template-columns: 1fr 1fr 300px;\n  }\n\n  @media (max-width: 1300px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media (max-width: 810px) {\n    padding: 15px;\n  }\n}\n\n.containerTitle {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n}\n\n.fieldsContainer {\n  margin-top: 10px;\n  padding: 20px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.notificationsInfoContainer {\n  grid-column: 1/3;\n}\n\n.btnsBlock {\n  width: 100%;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  column-gap: 25px;\n  padding: 25px;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profilePage": `profilePage__gO0Ct`,
	"btnsBlock": `btnsBlock__LfgZH`,
	"profileFieldsBlock": `profileFieldsBlock__mnCkD`,
	"containerTitle": `containerTitle__hpz36`,
	"fieldsContainer": `fieldsContainer__tUQVM`,
	"notificationsInfoContainer": `notificationsInfoContainer__Q4aWt`
};
module.exports = ___CSS_LOADER_EXPORT___;
